import { render } from "./Faith.vue?vue&type=template&id=5263fa28&ts=true"
import script from "./Faith.vue?vue&type=script&lang=ts"
export * from "./Faith.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/vmchs.frontend/vmchs.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__